"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = exports.getPhysicsPosition = exports.applyPhysicsItem = exports.drawPhysicsItem = void 0;
var crokinoleGamepadCursors_sidecar_1 = require("@crokinole/cursors/crokinoleGamepadCursors-sidecar");
var crokinole_input_sidecar_1 = require("@crokinole/multi/crokinole_input-sidecar");
var spritesPieces_1 = require("@crokinole/recyclers/spritesPieces");
var crokinoleUi_menu_main_sidecar_1 = require("@crokinole/ui-menus/crokinoleUi_menu_main-sidecar");
var diveColors_1 = require("@dive/colors/diveColors");
var diveFont_sidecar_1 = require("@dive/fonts/diveFont-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var crokinolePucks_sidecar_1 = require("../entities/crokinolePucks-sidecar");
var crokinoleGamepad_1 = require("../input/crokinoleGamepad");
var crokinoleGamepad_sidecar_1 = require("../input/crokinoleGamepad-sidecar");
var physics_rapier_loader_sidecar_1 = require("../physics/physics_rapier_loader-sidecar");
var crokinoleCamera_sidecar_1 = require("./crokinoleCamera-sidecar");
var crokinoleDefs_sidecar_1 = require("./crokinoleDefs-sidecar");
var crokinoleGameState_1 = require("./crokinoleGameState");
var crokinoleGameState_sidecar_1 = require("./crokinoleGameState-sidecar");
var crokinoleRenderer_sidecar_1 = require("./crokinoleRenderer-sidecar");
var vectorUtils_sidecar_1 = require("@crokinole/to-engine/vectorUtils-sidecar");
var drawPhysicsItem = function (item, frame, tint) {
    var position = item.translation();
    var wp = crokinoleCamera_sidecar_1.crokinoleCamera.physicsToWorld(position.x, position.y);
    var sprite = spritesPieces_1.spritesPieces.getNext(wp.x, wp.y, frame);
    sprite.tint = tint;
    sprite.rotation = item.rotation();
    return sprite;
};
exports.drawPhysicsItem = drawPhysicsItem;
var applyPhysicsItem = function (item, sprite) {
    var position = item.translation();
    var wp = crokinoleCamera_sidecar_1.crokinoleCamera.physicsToWorld(position.x, position.y);
    sprite.x = wp.x;
    sprite.y = wp.y;
    sprite.rotation = item.rotation();
};
exports.applyPhysicsItem = applyPhysicsItem;
var getPhysicsPosition = function (item) {
    var position = item.translation();
    var wp = crokinoleCamera_sidecar_1.crokinoleCamera.physicsToWorld(position.x, position.y);
    return {
        x: wp.x,
        y: wp.y,
        rotation: item.rotation(),
    };
};
exports.getPhysicsPosition = getPhysicsPosition;
var render = function () {
    if (!physics_rapier_loader_sidecar_1.physics_rapier_loader.isLoaded()) {
        return;
    }
    var phys = physics_rapier_loader_sidecar_1.physics_rapier_loader.get();
    crokinolePucks_sidecar_1.crokinolePucks.renderAll();
    var isInMenu = crokinoleUi_menu_main_sidecar_1.crokinoleUi_menu_main.isOpen();
    // drawPuck(puck1, diveColors.green)
    // drawPuck(puck2, diveColors.blueGray)
    // drawPhysicsItem(
    //   knocker,
    //   sprites.crokinoleCrokinolePiece[0],
    //   diveColors.orange,
    // )
    var state = crokinoleGameState_sidecar_1.crokinoleGameState.get();
    var cursorPhysicsPos = crokinoleCamera_sidecar_1.crokinoleCamera.getCursorPhysicsPosition();
    var currentPlayer = crokinoleGameState_sidecar_1.crokinoleGameState.getCurrentPlayer();
    var currentPp = crokinoleGameState_sidecar_1.crokinoleGameState.getCrokinolePlayerPosition(currentPlayer);
    var gpi = crokinoleGamepad_sidecar_1.crokinoleGamepad.getInput(currentPlayer.gamepadNum);
    var isGamepadAccept = gpi.x === crokinoleGamepad_1.InputState.JustDown ||
        gpi.a === crokinoleGamepad_1.InputState.JustDown ||
        gpi.bumperRight === crokinoleGamepad_1.InputState.JustDown ||
        gpi.triggerRight === crokinoleGamepad_1.InputState.JustDown;
    var isGamepadDelete = gpi.y === crokinoleGamepad_1.InputState.JustDown ||
        gpi.b === crokinoleGamepad_1.InputState.JustDown ||
        gpi.bumperLeft === crokinoleGamepad_1.InputState.JustDown ||
        gpi.triggerLeft === crokinoleGamepad_1.InputState.JustDown;
    for (var iPlayer = 0; iPlayer < state.players.length; iPlayer++) {
        var player = state.players[iPlayer];
        var pp = crokinoleGameState_sidecar_1.crokinoleGameState.getCrokinolePlayerPosition(player);
        // Show pieces left
        var piecesLeft = player.numTokensLeft;
        if (state.state === crokinoleGameState_1.CrokinoleGameStates.place) {
            if (player === currentPlayer) {
                piecesLeft--;
            }
        }
        var xMult = 500;
        var yMult = 500;
        for (var iPieceLeft = 0; iPieceLeft < piecesLeft; iPieceLeft++) {
            var pieceSize = 8;
            crokinolePucks_sidecar_1.crokinolePucks.renderAt(player, pp.piecesOffsetX * xMult - voyageCamera_sidecar_1.voyageCamera.get().cameraX, -pp.piecesOffsetY * yMult -
                iPieceLeft * pieceSize -
                voyageCamera_sidecar_1.voyageCamera.get().cameraY, 0, false);
        }
        // Show pieces in hole
        var piecesInHole = player.numTokensInHole;
        if (piecesInHole > 0) {
            var spriteHoleIndicator = spritesPieces_1.spritesPieces.getNext(pp.piecesInHoleOffsetX * xMult - voyageCamera_sidecar_1.voyageCamera.get().cameraX, -pp.piecesInHoleOffsetY * yMult - voyageCamera_sidecar_1.voyageCamera.get().cameraY, sprites_sidecar_1.sprites.crokinoleBoundary[0]);
            spriteHoleIndicator.tint = player.color;
        }
        for (var iPieceInHole = 0; iPieceInHole < piecesInHole; iPieceInHole++) {
            var pieceSize = 8;
            crokinolePucks_sidecar_1.crokinolePucks.renderAt(player, pp.piecesInHoleOffsetX * xMult - voyageCamera_sidecar_1.voyageCamera.get().cameraX, -pp.piecesInHoleOffsetY * yMult -
                iPieceInHole * pieceSize -
                voyageCamera_sidecar_1.voyageCamera.get().cameraY, 0, false);
            // let spritePieceInHole = spritesPieces.getNext(
            //   sprites.crokinoleCrokinolePiece[0],
            // )
            // spritePieceInHole.tint = player.color
            // console.log('render', 'piece', iPlayer, iPieceLeft, sprite.x, sprite.y)
        }
        // Show score
        var playerScore = crokinoleGameState_sidecar_1.crokinoleGameState.calcScoreForPlayer(player);
        // let playerScoreString = `${playerScore.onBoard} + ${playerScore.numInHole}x20 = ${playerScore.total}`
        var playerScoreString = playerScore.total + " (" + playerScore.onBoard + " + " + playerScore.numTeamInHole + "x20)";
        diveFont_sidecar_1.diveFont.writeAbsolute(pp.piecesOffsetX * xMult - voyageCamera_sidecar_1.voyageCamera.get().cameraX + 40, -pp.piecesOffsetY * yMult - voyageCamera_sidecar_1.voyageCamera.get().cameraY + 0, '' + playerScoreString, 0.5, diveColors_1.diveColors.pureWhite);
    }
    if (state.state === crokinoleGameState_1.CrokinoleGameStates.place) {
        // let cursorPos = crokinoleCamera.worldToPhysics()
        // phys.placerSensor.setTranslation()
        if (currentPlayer.controlScheme === crokinoleGameState_1.CrokinoleControlScheme.gamepad) {
            var gp = crokinoleGamepadCursors_sidecar_1.crokinoleGamepadCursors.getByGamepadNumber(currentPlayer.gamepadNum);
            if (gp) {
                crokinoleGamepadCursors_sidecar_1.crokinoleGamepadCursors.setColor(gp, currentPlayer.color);
            }
            // TODO: move to gamepad cursor
            if (!crokinoleGamepad_sidecar_1.crokinoleGamepad.isAxisInDeadzone(gpi.axis1X, gpi.axis1Y)) {
                var gamepadCameraSpeed = 5;
                crokinoleCamera_sidecar_1.crokinoleCamera.moveCameraByOffset(gpi.axis1X * gamepadCameraSpeed, gpi.axis1Y * gamepadCameraSpeed);
            }
            // if (!crokinoleGamepad.isAxisInDeadzone(gpi.axis2X, gpi.axis2Y)) {
            //   let gamepadSpeed = 0.05
            //   state.gamepadX += gpi.axis2X * gamepadSpeed
            //   state.gamepadY += -gpi.axis2Y * gamepadSpeed
            // }
            var gpc = crokinoleGamepadCursors_sidecar_1.crokinoleGamepadCursors.getByGamepadNumber(currentPlayer.gamepadNum);
            if (gpc) {
                phys.placerSensor.setTranslation({
                    x: gpc.physicsX,
                    y: gpc.physicsY, //  state.gamepadY,
                }, true);
            }
        }
        var sensorShape = phys.placerSensor.collider(0).shape; // new RAPIER.(1.0, 2.0);
        // let shapePos = { x: 1.0, y: 2.0 }
        // let shapeRot = 0.1
        var hasCollision_1 = false;
        var isOnPlayArea_1 = false;
        var collidedPuck_1 = null;
        phys.world.intersectionsWithShape(phys.placerSensor.translation(), phys.placerSensor.rotation(), sensorShape, function (handle) {
            // if (handle.isSensor()) {
            //   return true
            // }
            var parent = handle.parent();
            if (!(parent === null || parent === void 0 ? void 0 : parent.userData)) {
                // Skip if no user data
                hasCollision_1 = true;
                return true;
            }
            var userData = parent.userData;
            var type = (userData === null || userData === void 0 ? void 0 : userData.type) || 'unknown';
            // console.log('collided with', type)
            if (type === 'knocker') {
                // Ignore
                return true;
            }
            if (type === 'placer') {
                // Ignore
                return true;
            }
            if (type === 'hole') {
                hasCollision_1 = true;
                return true;
            }
            if (type === 'playarea') {
                // console.log('collided with', type)
                isOnPlayArea_1 = true;
                return true;
            }
            if (type === 'puck') {
                assert_sidecar_1.assert.notNil(userData.puck, 'puck is nil');
                collidedPuck_1 = userData.puck;
            }
            // console.log('The collider', handle, 'intersects our shape.')
            hasCollision_1 = true;
            return true; // Return `false` instead if we want to stop searching for other colliders that contain this point.
        });
        var isOnStartLine = crokinolePucks_sidecar_1.crokinolePucks.calcIsOnCenterLineEx(phys.placerSensor.translation().x, phys.placerSensor.translation().y);
        var isInCorrectQuadrant = false;
        isInCorrectQuadrant =
            crokinolePucks_sidecar_1.crokinolePucks.calcQuadrantEx(phys.placerSensor.translation().x, phys.placerSensor.translation().y) === currentPp.quadrant;
        if (!crokinoleDefs_sidecar_1.crokinoleDefs.rule_requireOnStartingLine) {
            isOnStartLine = true;
        }
        // Debug scoring
        var debugLine = '';
        var wp = crokinoleCamera_sidecar_1.crokinoleCamera.physicsToWorld(phys.placerSensor.translation().x, phys.placerSensor.translation().y);
        if (crokinoleDefs_sidecar_1.crokinoleDefs.debugScoring) {
            debugLine += crokinolePucks_sidecar_1.crokinolePucks.calcScoreForPuckEx(phys.placerSensor.translation().x, phys.placerSensor.translation().y);
        }
        if (crokinoleDefs_sidecar_1.crokinoleDefs.debugIsInCenter) {
            debugLine += crokinolePucks_sidecar_1.crokinolePucks.calcIsInCenterEx(phys.placerSensor.translation().x, phys.placerSensor.translation().y)
                ? 'C-Y'
                : 'C-N';
        }
        if (crokinoleDefs_sidecar_1.crokinoleDefs.debugQuadrant) {
            debugLine += crokinolePucks_sidecar_1.crokinolePucks.calcQuadrantEx(phys.placerSensor.translation().x, phys.placerSensor.translation().y);
        }
        if (crokinoleDefs_sidecar_1.crokinoleDefs.debugIsOnStartingLine) {
            debugLine += isOnStartLine ? 'SL-Y' : 'SL-N';
        }
        if (debugLine) {
            diveFont_sidecar_1.diveFont.writeAbsolute(wp.x + 30, wp.y + 30, debugLine, 0.5, diveColors_1.diveColors.darkBlue);
        }
        var placeSensorTint = diveColors_1.diveColors.green;
        var placePuckTint = currentPlayer.color;
        var isValidPlacement = !hasCollision_1 && isOnPlayArea_1;
        if (crokinoleDefs_sidecar_1.crokinoleDefs.rule_requireOnStartingLine) {
            if (!isOnStartLine) {
                isValidPlacement = false;
            }
        }
        if (crokinoleDefs_sidecar_1.crokinoleDefs.rule_requireQuadrant) {
            if (!isInCorrectQuadrant) {
                isValidPlacement = false;
            }
        }
        if (!isValidPlacement) {
            placeSensorTint = diveColors_1.diveColors.red;
        }
        if (!isInMenu) {
            var sensorSprite = exports.drawPhysicsItem(phys.placerSensor, sprites_sidecar_1.sprites.crokinoleBoundary[0], placeSensorTint);
            if (currentPlayer.numTokensLeft > 0) {
                // let sensorSprite2 = drawPhysicsItem(
                //   phys.placerSensor,
                //   sprites.crokinoleCrokinolePiece[0],
                //   placePuckTint,
                // )
                var puckPos = crokinoleRenderer_sidecar_1.crokinoleRenderer.getPhysicsPosition(phys.placerSensor);
                crokinolePucks_sidecar_1.crokinolePucks.renderAt(currentPlayer, puckPos.x, puckPos.y, 0, hasCollision_1);
                // if (hasCollision) {
                //   sensorSprite2.alpha = 0.5
                // }
            }
            if (clickEater_sidecar_1.clickEater.isLeftFirstDownAndUneaten() || isGamepadAccept) {
                clickEater_sidecar_1.clickEater.tempEat();
                if (isValidPlacement) {
                    if (currentPlayer.numTokensLeft > 0) {
                        // TODO: convert this to a network command!
                        crokinole_input_sidecar_1.crokinole_input.requestHost({
                            hint: crokinole_input_sidecar_1.crokinole_input.ECrokinoleInputHint.PlaceDisc,
                            frame: 0,
                            targetId: 0,
                            wx: phys.placerSensor.translation().x,
                            wy: phys.placerSensor.translation().y,
                            angle: phys.placerSensor.rotation(),
                            playerNum: currentPlayer.playerNum,
                        });
                        // currentPlayer.numTokensLeft--
                        // state.currentPuck = crokinolePucks.create(
                        //   phys.placerSensor.translation().x,
                        //   phys.placerSensor.translation().y,
                        //   crokinoleGameState.getCurrentPlayer(),
                        // )
                        // crokinoleGameState.advanceState()
                    }
                }
            }
            if (clickEater_sidecar_1.clickEater.isRightFirstDownAndUneaten() || isGamepadDelete) {
                clickEater_sidecar_1.clickEater.tempEat();
                if (collidedPuck_1) {
                    crokinolePucks_sidecar_1.crokinolePucks.kill(collidedPuck_1);
                }
            }
        }
    }
    else if (state.state === crokinoleGameState_1.CrokinoleGameStates.flick) {
        if (!isInMenu) {
            var currentPuck = state.currentPuck;
            if (!currentPuck || crokinolePucks_sidecar_1.crokinolePucks.isInactive(currentPuck)) {
                crokinoleGameState_1.advanceState();
            }
            if (currentPuck && !crokinolePucks_sidecar_1.crokinolePucks.isInactive(currentPuck)) {
                var puckPos = currentPuck.rigidBody.translation();
                var maxMagnitude = 2.5;
                var flingerPhysicsPos = {
                    x: cursorPhysicsPos.x,
                    y: cursorPhysicsPos.y,
                };
                if (currentPlayer.controlScheme === crokinoleGameState_1.CrokinoleControlScheme.gamepad) {
                    var gp = crokinoleGamepadCursors_sidecar_1.crokinoleGamepadCursors.getByGamepadNumber(currentPlayer.gamepadNum);
                    if (gp) {
                        crokinoleGamepadCursors_sidecar_1.crokinoleGamepadCursors.setColor(gp, currentPlayer.color);
                        flingerPhysicsPos.x = gp.physicsX;
                        flingerPhysicsPos.y = gp.physicsY;
                    }
                }
                var flingerToPuck1Delta = {
                    x: flingerPhysicsPos.x - puckPos.x,
                    y: flingerPhysicsPos.y - puckPos.y,
                };
                var magPrime = vectorUtils_sidecar_1.vectorUtils.magnitude(flingerToPuck1Delta);
                var puckSize = 0.2;
                // Make sure we are a minimum distance away from the puck
                if (magPrime >= puckSize) {
                    if (currentPlayer.controlScheme === crokinoleGameState_1.CrokinoleControlScheme.gamepad) {
                        flingerToPuck1Delta.x = gpi.axis2X * maxMagnitude;
                        flingerToPuck1Delta.y = -gpi.axis2Y * maxMagnitude;
                        magPrime = vectorUtils_sidecar_1.vectorUtils.magnitude(flingerToPuck1Delta);
                    }
                    var flingOx = 0;
                    var flingOy = 0;
                    var flingerToHitPoint1Delta = {
                        x: flingerPhysicsPos.x - puckPos.x,
                        y: flingerPhysicsPos.y - puckPos.y,
                    };
                    if (crokinoleDefs_sidecar_1.crokinoleDefs.rule_advancedFlingPosition2) {
                        var anglePrime = vectorUtils_sidecar_1.vectorUtils.angle(flingerToPuck1Delta); // + mathUtils.turn(0.5)
                        var magBeforeTransform = vectorUtils_sidecar_1.vectorUtils.magnitude(flingerToHitPoint1Delta);
                        var elapsed = common_sidecar_1.common.getElapsedTime();
                        var angleOffsetAmount = mathUtils_sidecar_1.mathUtils.turn(1 / 24);
                        var angleOffset = mathUtils_sidecar_1.mathUtils.sineLike(elapsed, 2, -angleOffsetAmount, angleOffsetAmount);
                        anglePrime += angleOffset;
                        var _flingOx = -mathUtils_sidecar_1.mathUtils.cos(anglePrime);
                        var _flingOy = -mathUtils_sidecar_1.mathUtils.sin(anglePrime);
                        var scale = 1; // 0.1
                        flingerPhysicsPos.x -= _flingOx * scale;
                        flingerPhysicsPos.y -= _flingOy * scale;
                        flingerToHitPoint1Delta = {
                            x: flingerPhysicsPos.x - puckPos.x,
                            y: flingerPhysicsPos.y - puckPos.y,
                        };
                        flingerToHitPoint1Delta = vectorUtils_sidecar_1.vectorUtils.normalize(flingerToHitPoint1Delta);
                        flingerToHitPoint1Delta = vectorUtils_sidecar_1.vectorUtils.scale(flingerToHitPoint1Delta, magBeforeTransform);
                        // cursorToHitPoint1Delta.x += flingOx
                        // cursorToHitPoint1Delta.y += flingOy
                        // let offset = 10
                        // flingOx = mathUtils.cos(angle) * offset
                        // flingOy = mathUtils.sin(angle) * offset
                    }
                    if (crokinoleDefs_sidecar_1.crokinoleDefs.rule_advancedFlingPosition) {
                        var anglePrime = vectorUtils_sidecar_1.vectorUtils.angle(flingerToPuck1Delta) + mathUtils_sidecar_1.mathUtils.turn(0.5);
                        var elapsed = common_sidecar_1.common.getElapsedTime();
                        var angleOffsetAmount = mathUtils_sidecar_1.mathUtils.turn(1 / 6);
                        var angleOffset = mathUtils_sidecar_1.mathUtils.sineLike(elapsed, 2, -angleOffsetAmount, angleOffsetAmount);
                        anglePrime += angleOffset;
                        flingOx = -mathUtils_sidecar_1.mathUtils.cos(anglePrime) * puckSize;
                        flingOy = -mathUtils_sidecar_1.mathUtils.sin(anglePrime) * puckSize;
                        // cursorToHitPoint1Delta.x += flingOx
                        // cursorToHitPoint1Delta.y += flingOy
                        // let offset = 10
                        // flingOx = mathUtils.cos(angle) * offset
                        // flingOy = mathUtils.sin(angle) * offset
                    }
                    // if (crokinoleDefs.rule_advancedFlingPosition2) {
                    //   let anglePrime =
                    //     vectorUtils.angle(flingerToPuck1Delta) + mathUtils.turn(0.5)
                    //   let elapsed = common.getElapsedTime()
                    //   let angleOffsetAmount = mathUtils.turn(1 / 12)
                    //   let angleOffset = mathUtils.sineLike(
                    //     elapsed,
                    //     2,
                    //     -angleOffsetAmount,
                    //     angleOffsetAmount,
                    //   )
                    //   anglePrime += angleOffset
                    //   flingOx = -mathUtils.cos(anglePrime) * puckSize
                    //   flingOy = -mathUtils.sin(anglePrime) * puckSize
                    //   // cursorToHitPoint1Delta.x += flingOx
                    //   // cursorToHitPoint1Delta.y += flingOy
                    //   // let offset = 10
                    //   // flingOx = mathUtils.cos(angle) * offset
                    //   // flingOy = mathUtils.sin(angle) * offset
                    // }
                    var angle = vectorUtils_sidecar_1.vectorUtils.angle(flingerToHitPoint1Delta);
                    //console.log('mag is', mag)
                    var mag = vectorUtils_sidecar_1.vectorUtils.magnitude(flingerToHitPoint1Delta);
                    if (mag > maxMagnitude) {
                        // Scale to max mag
                        flingerToHitPoint1Delta = vectorUtils_sidecar_1.vectorUtils.normalize(flingerToHitPoint1Delta);
                        flingerToHitPoint1Delta = vectorUtils_sidecar_1.vectorUtils.scale(flingerToHitPoint1Delta, maxMagnitude);
                        mag = maxMagnitude;
                        //console.log('mag is', mag)
                    }
                    // Draw our hit indicators
                    for (var i = 0; i <= 5; i++) {
                        var t = i / 5;
                        var v = vectorUtils_sidecar_1.vectorUtils.normalize(flingerToHitPoint1Delta);
                        v = vectorUtils_sidecar_1.vectorUtils.scale(v, t * mag);
                        v = vectorUtils_sidecar_1.vectorUtils.add(v, puckPos);
                        v = vectorUtils_sidecar_1.vectorUtils.add(v, { x: flingOx, y: flingOy });
                        var wp = crokinoleCamera_sidecar_1.crokinoleCamera.physicsToWorld(v.x, v.y);
                        var sprite = spritesPieces_1.spritesPieces.getNext(wp.x, wp.y, sprites_sidecar_1.sprites.crokinoleCrokinoleArrow[0]);
                        sprite.rotation = -angle + mathUtils_sidecar_1.mathUtils.turn(-0.25);
                    }
                    if (clickEater_sidecar_1.clickEater.isLeftFirstDownAndUneaten() || isGamepadAccept) {
                        clickEater_sidecar_1.clickEater.tempEat();
                        // TODO: only apply on step?
                        // TODO: move fling elsewhere
                        var impulseMultiplier = 0.75;
                        // TODO: timing for left and right
                        crokinole_input_sidecar_1.crokinole_input.requestHost({
                            hint: crokinole_input_sidecar_1.crokinole_input.ECrokinoleInputHint.FlingDisc,
                            frame: 0,
                            targetId: currentPuck.id,
                            wx: puckPos.x + flingOx,
                            wy: puckPos.y + flingOy,
                            fx: flingerToHitPoint1Delta.x * -impulseMultiplier,
                            fy: flingerToHitPoint1Delta.y * -impulseMultiplier,
                            angle: phys.placerSensor.rotation(),
                            playerNum: currentPlayer.playerNum,
                        });
                    }
                }
            }
        }
    }
    // Render pegs
    for (var i = 0; i < phys.poles.length; i++) {
        var pole = phys.poles[i];
        exports.drawPhysicsItem(pole, sprites_sidecar_1.sprites.crokinoleCrokinolePeg[0], diveColors_1.diveColors.gray);
    }
    // Check sensor
    var sensorColor = diveColors_1.diveColors.peach;
    //intersectionsWith
    phys.world.intersectionPairsWith(phys.holeSensor.collider(0), function () {
        // see: https://rapier.rs/docs/user_guides/javascript/advanced_collision_detection_js
        // console.log(namespace, 'sensor hit', otherCollider)
        sensorColor = diveColors_1.diveColors.red;
    });
    if (crokinoleDefs_sidecar_1.crokinoleDefs.debugHole) {
        exports.drawPhysicsItem(phys.holeSensor, sprites_sidecar_1.sprites.crokinoleBoundary[0], sensorColor);
    }
    // Render green arc
};
exports.render = render;
